<div class="relative bg-white rounded-2xl shadow-xl w-full overflow-hidden flex flex-col">
    <ng-container *ngIf="hasHeader; then header"></ng-container>
    <div class="flex-1 overflow-y-auto p-4">
        <ng-content></ng-content>
    </div>
    <ng-container *ngIf="hasFooter; then footer"></ng-container>
</div>

<ng-template #header>
    <div class="flex items-center justify-between p-4 border-b border-gray-200">
        <h2 class="text-lg font-semibold text-gray-900">
            記録タイトルを選択
        </h2>
        <ng-container *ngTemplateOutlet="xclose"></ng-container>
    </div>
</ng-template>

<ng-template #footer>
    <div class="p-4 border-t border-gray-200 flex flex-col gap-3">
        <ng-container *ngFor="let button of buttons">
            <button (click)="closeDialog(button.data)" [disabled]="button.disabled" [ngClass]="button.classes ? button.classes.join(' ') : 
                'w-full bg-gray-100 text-gray-700 rounded-xl py-3 font-medium hover:bg-gray-200 transition-colors'">
                {{button.text}}
            </button>
        </ng-container>
    </div>
</ng-template>

<ng-template #xclose>
    <button (click)="closeDialog(null)" class="p-2 hover:bg-gray-100 rounded-lg transition-colors"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-x w-5 h-5 text-gray-500">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
        </svg>
    </button>
</ng-template>